module.exports = __webpack_public_path__ + "static/img/autumn_banner.f2b8b06a.jpg";